import {Chip} from '@dropbox/dig-components/chip';
import {Text} from '@dropbox/dig-components/typography';
import {Box} from '@dropbox/dig-foundations';
import {UIIcon} from '@dropbox/dig-icons';

import {DocumentStatus} from './types';
import {getStatusBorder, getStatusColor, getStatusIconColor, getStatusText} from './utils';

type DocumentStatusChipProps = {
  status: DocumentStatus;
  statusIconSrc?: React.ComponentType<React.SVGAttributes<SVGElement>>;
  boldStatusText?: boolean;
  style?: React.CSSProperties;
  withDropdownSpace?: boolean;
};

export const DocumentStatusChip = ({
  status,
  statusIconSrc,
  boldStatusText = false,
  style,
  withDropdownSpace = false,
}: DocumentStatusChipProps) => {
  return (
    <Chip
      size="small"
      style={{
        ...style,
        backgroundColor: getStatusColor(status),
        border: getStatusBorder(status),
      }}
    >
      <DocumentStatusChipContent
        status={status}
        statusIconSrc={statusIconSrc}
        boldStatusText={boldStatusText}
        withDropdownSpace={withDropdownSpace}
      />
    </Chip>
  );
};

export const DocumentStatusChipContent = ({
  status,
  statusIconSrc,
  boldStatusText = false,
  withDropdownSpace = false,
}: Omit<DocumentStatusChipProps, 'size' | 'style'>) => {
  return (
    <Box
      display="flex"
      alignItems="center"
      marginRight={withDropdownSpace ? '4' : undefined}
      style={{gap: 4}}
    >
      {statusIconSrc && (
        <UIIcon size="small" color={getStatusIconColor(status)} src={statusIconSrc} />
      )}
      <Text size="small" isBold={boldStatusText}>
        {getStatusText(status)}
      </Text>
    </Box>
  );
};
